<template>

    <div>
        404
    </div>

</template>

<script>
    export default {

        name: 'erorr-404'
    }

</script>